import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import React from "react";
import { useNavigate } from "react-router-dom";

interface Chat {
    id: string;
    name: string;
    image: string;
    lastmessage: string;
    messages: { id: string; text: string; sender: string; timestamp: string }[];
}

interface SidebarProps {
    chats: Chat[];
    activeChat: Chat | null;
    setActiveChat: (chat: Chat) => void;
    isMobile?: boolean;
}

const Sidebar: React.FC<SidebarProps> = ({ chats, activeChat, setActiveChat, isMobile }) => {
    const navigate = useNavigate();

    const handleBack = () => {
        navigate(-1);
    }
    return (
        <div className={`${isMobile ? "w-full" : "w-1/4"} bg-gray-100 p-4`}>
            <div className="back-button !mt-0 !ml-0" onClick={handleBack}>
                <ArrowLeftIcon className="w-6 h-6 text-black-700" /><h3 className="m-0">Chats</h3>
            </div>
            <div className="mt-4">
                {chats.map((chat) => (
                    <div
                        key={chat.id}
                        className={`p-2 cursor-pointer ${activeChat?.id === chat.id ? "bg-purple-300" : "hover:bg-gray-200"
                            }`}
                        onClick={() => setActiveChat(chat)}
                    >
                        <div className="flex gap-2 items-center">
                            <img src={chat.image} alt={chat.name} className="rounded-full w-10 h-10" />
                            <div className="flex flex-col">
                                <span>{chat.name}</span>
                                <span>{chat.lastmessage}</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Sidebar;
